














































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormPage from "./FormPage/index.vue";
import ChartPage from "../../../components/ChartPage/index.vue";
import Api from "../../../api/index";
import request from "../../../api/request";
import { getCookie, getStorage } from "@szgc/plt-core-v2";
import { Loading } from "element-ui";
import UserSelect from "../../../components/UserSelect/index.vue";
import { trim, dateFormat } from "../../../util";
import LogTable from "../../../components/LogTable/index.vue";
import FileList from "../../../components/FileList/index.vue";
import { ElForm } from "element-ui/types/form";
import UploadFile from "../../../../pt/components/UploadFile/index.vue";
import UrgerSelect from "../../../../pt/components/UrgerSelect/index.vue";

@Component({
  name: "WbenDoneProcessMobile",
  components: {
    UploadFile,
    FormPage,
    ChartPage,
    UserSelect,
    LogTable,
    FileList,
    UrgerSelect
  }
})
export default class WbenDoneProcessMobile extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: [String, Number],
    default: "all"
  })
  private logType!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private businessId: any = null;
  private title: any = "";
  private userName: any = "";
  private timeText: any = "";
  private procTaskName: any = "";
  private realName: any = "";
  private processData: any = null;
  private leftFormData: any = null;
  private doneBtns: any = [];
  private doneBtnNum: number = 0;
  private nowTodoBtn: any = null;
  private doneFlag: any = {
    ifAttEnable: false,
    ifAttRequire: false,
    ifUserEnable: false,
    ifUserRequire: false
  };
  private doneUserBox: any = {
    show: false
  };
  private toUsers: any = [];
  private rulesTodo: any = {};
  private doneModalShow: boolean = false;
  private doneForm: any = {
    userName: "",
    userId: "",
    fileName: "",
    fileId: "",
    idea: ""
  };
  private transmitModalShow: boolean = false;
  private transmitForm: any = {
    userName: "",
    userId: "",
    idea: ""
  };
  private rulesTransmit: any = {
    userName: [{ required: true, message: "转发人接收人不能为空" }]
  };
  private transmitUserBox: any = {
    show: false
  };
  private transmitUsers: any = [];
  private fileUpdLoading: any = null;
  private reqToken: string = "";
  private prefix: string = "";
  private token: any = "";
  private fileData: any = [];
  private iframeUrl: string = "";
  private iframeHeight: string = "0px";
  private urgersShow: boolean = false; // 催办人弹窗

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || getStorage("plt-api-route") || "";
      this.token = getCookie("SZGC-SHIRO-TOKEN") || getStorage("SZGC-SHIRO-TOKEN") || "";
      // if (localStorage.getItem('offline') && localStorage.getItem('offline') === "true") {
      // }
      this.processData = JSON.parse(JSON.stringify(newVal));
      this.getFlowData();
    }
  }

  /*已办的流程事项数据查询*/
  async getFlowData(refresh: boolean = false) {
    const params = {
      businessId: this.processData.businessId,
      clientType: "web",
      procTaskId: this.processData.procTaskId
    };
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getDoneSingle(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error("获取已办的流程事项数据失败:" + message);
        return false;
      }
      if (refresh) {
        //退出编辑只更新左边表单数据
        this.leftFormData = data;
      } else {
        this.businessId = data.businessId;
        this.title = data.businessName;
        this.userName = data.run.createUserName;
        this.procTaskName = data.task.procTaskName;
        this.realName = data.task.realName;
        this.timeText = data.run.createTime ? dateFormat(data.run.createTime) : "--";
        this.leftFormData = data; //给左边表单传入所有数据
        this.doneBtns = data.doneList; //相关意见虚线下方按钮
        let total: number = 0;
        this.doneBtns.map((item: any) => {
          if (item.enable) {
            total++;
          }
        });
        this.doneBtnNum = total;
      }
      this.reqToken = data.reqToken;
      this.fileData = data.atts;
      if (this.leftFormData.packageType === 3) {
        const iframeConfig: any = JSON.parse(this.leftFormData.fields.iframe.value);
        const path = iframeConfig.web;
        const searchParams = new URLSearchParams({
          businessId: this.businessId,
          procTaskId: this.processData.procTaskId,
          clientType: "web",
          page: "done"
        });
        if (path.indexOf("http:") > -1 || path.indexOf("https:") > -1) {
          this.iframeUrl = `${path}?${searchParams}`;
        } else {
          this.iframeUrl = `${window.origin}${path}?${searchParams}`;
        }
        this.iframeHeight = iframeConfig.padHeight + "px";
      }
    } catch (error: any) {
      this.$message.error("获取已办的流程事项数据失败:" + error);
    }
  }

  destroyed() {
    window.removeEventListener("message", this.getMessage);
  }

  /*iframe加载完毕*/
  bindEvent() {
    this.$nextTick(() => {
      window.addEventListener("message", this.getMessage);
    });
  }

  /*iframe子传父*/
  getMessage(event: any) {
    const data = event.data;
    if (data && data.data && data.type && data.type === "szgc-wbench-iframe") {
      if (data.page && data.page === "done") {
        this.handleDoneAction(data.data);
      }
    }
  }

  /*iframe父传子*/
  sendMessage(btnKey: any) {
    let iframe: any = this.$refs.wbenchIframe;
    iframe.contentWindow.postMessage(
      {
        page: "done",
        btnKey: btnKey,
        type: "szgc-wbench-iframe"
      },
      this.iframeUrl
    );
  }

  /*done操办人选择*/
  doneUserChecked(data: any) {
    if (data.source.length === 0) {
      this.toUsers = [];
      this.doneForm.userName = "";
      this.doneForm.userId = "";
      return;
    }
    this.doneForm.userName = data.text;
    this.doneForm.userId = data.valueText;
    this.toUsers = this.doneForm.userId.split(",");
  }

  /*转发接收人弹窗*/
  showTransmitUserBox() {
    this.transmitUserBox.show = true;
  }

  /*转发接收人选择*/
  transmitUserChecked(data: any) {
    if (data.source.length === 0) {
      this.transmitUsers = [];
      this.transmitForm.userName = "";
      this.transmitForm.userId = "";
      return;
    }
    this.transmitForm.userName = data.text;
    this.transmitForm.userId = data.valueText;
    this.transmitUsers = this.transmitForm.userId.split(",");
  }

  /*转发弹窗*/
  transmitEvt() {
    this.transmitModalShow = true;
  }

  /*转发提交*/
  async transmit() {
    let flag;
    await (this.$refs.wbenTransmitForm as ElForm).validate((valid: any) => {
      flag = valid;
    });
    if (flag) {
      let ccs: any = [];
      if (this.transmitForm.userName !== "") {
        //转发人
        let ccUserIds = this.transmitForm.userId.split(","),
          ccUserNames = this.transmitForm.userName.split(",");
        for (let i = 0; i < ccUserIds.length; i++) {
          ccs.push({
            realName: ccUserNames[i],
            userId: ccUserIds[i]
          });
        }
      }
      try {
        const { success, message } = await request({
          url: this.prefix + Api.transmitProcess(),
          method: "post",
          data: {
            businessName: this.leftFormData.businessName,
            businessId: this.leftFormData.businessId,
            ccs: ccs.length > 0 ? ccs : null,
            idea: trim(this.transmitForm.idea),
            proTaskId: this.leftFormData.task.procTaskId,
            procTaskName: this.leftFormData.task.procTaskName,
            utKey: this.leftFormData.task.utKey
          }
        });
        if (!success) {
          this.$message.error(`转发失败:${message}`);
          return false;
        }
        this.transmitModalShow = false;
        this.$message.success(`转发成功`);
        this.$emit("childEvt", { type: "close" }); //触发完直接关闭弹窗
      } catch (error: any) {
        this.$message.error(`转发失败:${error}`);
      }
    }
  }

  /*doneBtn点击虚线下方按钮*/
  doneBtnEvt(item: any) {
    this.nowTodoBtn = item;
    this.doneFlag = {
      ifAttEnable: item.ifAttEnable,
      ifAttRequire: item.ifAttRequire,
      ifUserEnable: item.ifUserEnable,
      ifUserRequire: item.ifUserRequire
    };
    this.doneForm = {
      userName: "",
      userId: "",
      fileName: "",
      fileId: "",
      idea: ""
    };
    if (this.nowTodoBtn.needSecondSubmit) {
      //有二次提交
      this.rulesTodo = {
        userName: [{ required: this.doneFlag.ifUserRequire, message: "操办人不能为空" }],
        fileName: [{ required: this.doneFlag.ifAttRequire, message: "附件不能为空" }]
      };
      this.doneModalShow = true;
    } else {
      this.rulesTodo = null;
      this.doneBtnAction();
    }
  }

  /*doneBtn确定*/
  async doneSureEvt() {
    let flag;
    await (this.$refs.wbenTodoBtnForm as any).validate((valid: any) => {
      flag = valid;
    });
    if (flag) {
      this.doneBtnAction();
    }
  }

  /*doneBtn提交*/
  async doneBtnAction() {
    let formBoxData = {};
    if (this.leftFormData.packageType !== 3) {
      //非iframe
      if (this.nowTodoBtn.btnKey === "recall") {
        //撤回recall
        const allData = await (this.$refs.wbenDoneForm as any).getBackFormData(false);
        formBoxData = allData.data;
      } else {
        const allData = await (this.$refs.wbenDoneForm as any).getBackFormData();
        if (!allData.valid) {
          this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
          return false;
        }
        formBoxData = allData.data;
      }
      this.handleDoneAction(formBoxData);
    } else {
      this.sendMessage(this.nowTodoBtn.btnKey);
    }
  }

  /*doneBtn接口请求*/
  async handleDoneAction(formBoxData: any) {
    let nextCus: any = [];
    if (this.doneForm.userId !== "") {
      //操办人
      let userIds = this.doneForm.userId.split(","),
        userNames = this.doneForm.userName.split(",");
      for (let j = 0; j < userIds.length; j++) {
        nextCus.push({
          realName: userNames[j],
          userId: userIds[j]
        });
      }
    }
    try {
      const { success, message } = await request({
        url: this.prefix + Api.doneTaskFunc(),
        method: "post",
        data: {
          procTaskId: this.leftFormData.task.procTaskId,
          attIds: this.doneForm.fileId === "" ? null : this.doneForm.fileId,
          btnKey: this.nowTodoBtn.btnKey,
          businessId: this.processData.businessId,
          ccs: null,
          fields: formBoxData,
          idea: trim(this.doneForm.idea),
          nextCus: nextCus,
          reqToken: this.reqToken
        }
      });
      if (!success) {
        this.$message.error(`${this.nowTodoBtn.btnName}失败:${message}`);
        return false;
      }
      this.$message.success(`${this.nowTodoBtn.btnName}成功`);
      this.doneModalShow = false;
      this.$emit("childEvt", { type: "close" });
    } catch (error: any) {
      this.$message.error(`${this.nowTodoBtn.btnName}失败:${error}`);
    }
  }

  /*多文件上传点击*/
  showMulUpload() {
    (document.getElementById("submitUploadFile") as any).value = "";
    (document.getElementById("submitUploadFile") as HTMLDivElement).click();
  }

  /*多文件上传*/
  multiUpload(event: any) {
    let files = event.target.files;
    let formData = new FormData();
    if (files.length === 0) {
      return false;
    }
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    this.fileUpdLoading = Loading.service({
      lock: true,
      fullscreen: true,
      text: "附件上传中..."
    });
    request({
      url: this.prefix + Api.mulUploadFiles,
      method: "post",
      data: formData
    })
      .then((res: any) => {
        if (res.success) {
          let tempIds: any = [],
            tempNames: any = [];
          if (res.data && res.data.length && res.data.length > 0) {
            res.data.map((item: any) => {
              tempIds.push(item.fileId);
              tempNames.push(item.name);
            });
          }
          this.doneForm.fileName = tempNames.join(",");
          this.doneForm.fileId = tempIds;
          this.$message.success("附件上传成功");
        } else {
          this.doneForm.fileName = "";
          this.doneForm.fileId = "";
          this.$message.error("附件上传失败");
        }
        this.fileUpdLoading.close();
      })
      .catch((error: any) => {
        this.doneForm.fileName = "";
        this.doneForm.fileId = "";
        this.fileUpdLoading.close();
        this.$message.error("附件上传失败: " + error);
      });
  }

  /*左边表单点击操作按钮之后关闭弹窗*/
  childEvt(data: any) {
    if (data.type === "close") {
      this.$emit("childEvt", { type: "close" });
    } else if (data.type === "refresh") {
      this.getFlowData(true);
    }
  }

  /* 催办先选人 */
  async urgeEvt() {
    this.urgersShow = true;
  }

  /* 催办 */
  async handleUrgeEvt(data: any) {
    try {
      const urgerIds: any = [...data.childMatterUrgers, ...data.curMatterUrgers];
      const { success, message } = await request({
        url: this.prefix + Api.urgeProcess(this.processData.businessId),
        method: "put",
        data: {
          urgerIds
        }
      });
      if (!success) {
        this.$message.error(`催办失败:${message}`);
        return false;
      }
      this.$message.success(`催办成功`);
      this.urgersShow = false;
    } catch (error) {
      this.$message.error(`催办失败:${error}`);
    }
  }
}
